<template>
  <div>
    <div class="input-tips">
      <i class="el-icon-info" style="color: #409EFF; margin-right: 5px;"></i>
      <span>支持多个运单号，每个运单号请以逗号","分割，最多支300个运单号</span>
    </div>

    <el-input
      v-model="batchOrderCodes"
      type="textarea"
      :rows="10"
      placeholder="请在此输入运单号,示例:TZ000000000,TZ111111111"
      style="width: 100%; margin-top: 15px;"
      class="batch-textarea"
    />

    <div class="order-count">
      <span>
        <i class="el-icon-document" style="margin-right: 5px;"></i>
        已识别运单号：<strong style="color: #409EFF;">{{
          parsedOrderCodes.length
        }}</strong>
        个
      </span>
    </div>

    <div v-if="parsedOrderCodes.length > 300" class="warning-tip">
      <i class="el-icon-warning" style="color: #E6A23C; margin-right: 5px;"></i>
      <span style="color: #E6A23C;"
        >运单号较多，建议分批查询以获得更好的性能</span
      >
    </div>

    <div style="text-align: right;margin-top:20px;">
      <el-button @click="clearBatchInput" icon="el-icon-delete">清空</el-button>
      <el-button type="primary" @click="confirmBatchInput" icon="el-icon-check"
        >确定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    codes: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      batchOrderCodes: ""
    };
  },
  computed: {
    // 解析批量输入的运单号
    parsedOrderCodes() {
      if (!this.batchOrderCodes.trim()) return [];
      let num = this.batchOrderCodes
        .split(/[\n\r]+/)
        .map(line => line.split(/[,，]+/))
        .flat()
        .map(code => code.trim())
        .filter(code => code.length > 0);

      return num;
    }
  },
  watch: {
    codes: {
      handler(newValue) {
        this.batchOrderCodes = newValue;
      },
      immediate: true
    },
    parsedOrderCodes: {
      handler(newValue, oldValue) {
        if (newValue.length > 300) {
          this.$message({
            message: "最多只能输入300个运单号",
            type: "warning"
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    confirmBatchInput() {
      this.$emit("confirmBatchInput", this.parsedOrderCodes);
    },
    clearBatchInput() {
      if (this.parsedOrderCodes.length === 0) return;
      this.$confirm("确认清空所有已输入的运单号吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.batchOrderCodes = "";
        })
        .catch(() => {});
    },
    handleBatchInputClose(done) {
      if (this.batchOrderCodes.trim()) {
        this.$confirm("关闭后将丢失已输入的内容，确认关闭吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            done();
          })
          .catch(() => {});
      } else {
        done();
      }
    }
  }
};
</script>
<style scoped lang="scss">
.input-tips {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f0f9ff;
  border-left: 4px solid #409eff;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
}

.format-examples {
  margin-bottom: 10px;
  padding: 12px;
  background-color: #fafafa;
  border-radius: 6px;
  border: 1px solid #e4e7ed;

  .example-item {
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .example-label {
    font-weight: 600;
    color: #303133;
    font-size: 13px;
  }

  .example-text {
    font-size: 12px;
    color: #606266;
    font-family: "Courier New", monospace;
  }
}

.batch-textarea {
  .el-textarea__inner {
    font-family: "Courier New", monospace;
    line-height: 1.6;
    resize: vertical;
    border-radius: 6px;

    &:focus {
      border-color: #409eff;
      box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
    }
  }
}

.order-count {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
  font-size: 13px;
  color: #606266;
  border: 1px solid #e4e7ed;
}

.warning-tip {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #fdf6ec;
  border-left: 4px solid #e6a23c;
  border-radius: 4px;
  font-size: 12px;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
}
</style>
